import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import Fields from '../Fields';
import style from './style';

const Styled = styled.div`
  ${style}
`;
const FieldsAggregate = props => {
  return (
    <Styled className={cn('general-aggregate')} {...props}>
      <Fields />
    </Styled>
  );
};

export default FieldsAggregate;
